module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "page_4"
    }
  }), _c('a', {
    attrs: {
      "href": "#/contenttoc#t4",
      "id": "c4"
    }
  }, [_vm._v("Meet Your Coaches and Resume Writers")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1"
  }, [_vm._v("The following professional career coaches and resume writers will be providing you with additional advice and insight throughout the book. They were selectively chosen based on their experience and professional credentials.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The career coaches and resume writers have graciously donated their time and their work. They did not receive any compensation to be included in this book.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("If you believe it would be beneficial to your job search to have a professional career coach, you are encouraged to reach out to these coaches. They are experienced in coaching recent college graduates with their job search.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Additionally, if you choose to have your resume professionally written, please consider contacting the resume writers in this book whose work appeals to you or perhaps located closest to you. Each resume writer has provided samples of their work (see Chapter 18).")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Understand that resume writing is an art form. It takes time and focused concentration. What you may see in the samples may not completely align with the instructional section of this book. However, each sample resume was written with a specific job, strategy, or goal in mind. You have the wonderful advantage of having the education of the instructional part of this book with their insight and the resume samples to blend and create your own unique resume. Or, you may decide that a professionally prepared resume is the right way to go.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a60732a6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/frontmatter05.vue
// module id = 78
// module chunks = 0